import { WorkshopTip } from '@/models/Workshop';
import { ApplicationState } from '@/store';
import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import './style.scss';

interface WorkshopTipProps {
    tip: WorkshopTip[];
}

const Tips = ({ tip }: WorkshopTipProps) => {
    const strings = useSelector((state: ApplicationState) => state.locale.data);
    return (
        <div className="container-workshop-tips">
            {tip.length > 0 && (
                <>
                    <span>{strings.WORKSHOP_CHECK_OUT_SOME_EXTRA_INFO}</span>
                    <div className="workshop-description">
                        {tip.map((tip: WorkshopTip) => (
                            <Fragment key={tip.id}>
                                <span className="item-description">
                                    <div className="item">
                                        <span className="index">{tip.workshopTipOrder + 1}</span>
                                    </div>
                                    {tip.description}
                                </span>
                            </Fragment>
                        ))}
                    </div>
                </>
            )}
        </div>
    );
};

export default React.memo(Tips);
